import { inject, Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { EventsService } from '@services/events/events.service';
import { StorageService } from '@services/storage/storage.service';
import { VariablesService } from '@services/variables/variables.service';
import { IOrder } from '@models/order.model';
import { MatButtonModule } from '@angular/material/button';
import { ThankyouSuccessHeadComponent } from '../../../thankyou-success-head/thankyou-success-head.component';
import { CurrencyIconComponent } from '@core-components/currency-icon/currency-icon.component';

@Component({
  selector: 'app-payment-successfull',
  standalone: true,
  imports: [
    MatButtonModule,
    ThankyouSuccessHeadComponent,
    CurrencyIconComponent
  ],
  templateUrl: './payment-successfull.component.html',
  styleUrls: ['./payment-successfull.component.scss']
})
export class PaymentSuccessfullComponent {

  private events = inject(EventsService);
  private vars = inject(VariablesService);
  private storage = inject(StorageService);

  @Input() order: IOrder;
  @Input() prizeAmount: number;
  @Output() public ontakeQuiz: EventEmitter<boolean> = new EventEmitter();
  private subscription: Subscription = new Subscription();

  ngAfterViewInit() {
    setTimeout(() => {
      this.takeQuiz();
    }, 10500);
  }
  /**
   * Show quiz page
   */
  takeQuiz(): void {
    this.ontakeQuiz.emit();
  }

  /**
   * Skips quiz
   */
  skipQuiz(): void {
    this.storage.addSessionData('showQuiz', false.toString());
    document.getElementById('sip-quiz-wrapper').style.display = 'none';
    this.subscription = this.events.sendSystemEvent({
      eventName: 'skip_quiz',
      info_3: 'impact'
    }).subscribe(_ => _);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
